import { render, staticRenderFns } from "./AskCustomEvaluation.vue?vue&type=template&id=8f4b05a0&scoped=true"
import script from "./AskCustomEvaluation.vue?vue&type=script&lang=js"
export * from "./AskCustomEvaluation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4b05a0",
  null
  
)

export default component.exports